import React, { PropsWithChildren } from "react";
import styled from "styled-components";

const Wrap = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100000;
`;
const Dimd = styled.div`
  position: absolute;
  top: inherit;
  left: inherit;
  width: inherit;
  height: inherit;
  background-color: rgba(0, 0, 0, 0.5);
`;
const ContentWrap = styled.div`
  position: absolute;
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  z-index: 1;
`;

type TProps = {
  onClickDimd?: React.MouseEventHandler<HTMLDivElement>;
} & PropsWithChildren;

export default function Modal(props: TProps) {
  return (
    <Wrap>
      <Dimd onClick={props.onClickDimd} />
      <ContentWrap>{props.children}</ContentWrap>
    </Wrap>
  );
}
